import { ibuttonService } from '../_services';
import { router } from '../_helpers';

const state = { onRequest: false, ibuttons: [], ibutton: {} };

const actions = {
    get({ dispatch, commit }, id) {
        commit('request');

        ibuttonService.get(id)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    add({ dispatch, commit }, data) {
        commit('request');

        ibuttonService.add(data)
            .then(
                async () => {
                    commit('success');
                    await router.push('/ibuttons');
                    dispatch('alert/success', "iButton Added Successfully", { root: true });
                },
                async error => {
                    commit('error');
                    await router.push('/ibuttons');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    edit({ dispatch, commit }, data) {
        commit('request');

        ibuttonService.edit(data)
            .then(
                async () => {
                    commit('success');
                    await router.push('/ibuttons');
                    dispatch('alert/success', "iButton Updated Successfully", { root: true });
                },
                async error => {
                    commit('error');
                    await router.push('/ibuttons');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    get_all({ dispatch, commit }) {
        commit('request');

        ibuttonService.get_all()
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    destroy({ dispatch, commit }, id){
      commit('request');

      ibuttonService.destroy(id)
          .then(
              async () => {
                  commit('success');
                  await router.go('/ibuttons');
                  dispatch('alert/success', "iButton Deleted Successfully", { root: true });
              },
              async error => {
                  commit('error');
                  await router.go('/ibuttons');
                  dispatch('alert/error', error, { root: true });
              }
          );
    },
    get_ibutton_by_account({ dispatch, commit }, data) {
        commit('request');

        ibuttonService.get_ibutton_by_account(data)
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  ibuttons: state => {
    return state.ibuttons
  },
  ibutton: state => {
    return state.ibutton
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.ibutton = {};
        state.ibuttons = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.ibutton = data;
    },
    success_datas(state, data) {
      state.onRequest = false;
      state.ibuttons = data;
    },
    error(state) {
        state.onRequest = false;
    },
};

export const ibuttons = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
